import { css } from "@emotion/react";

export const UplineContactModalStyle = {
  wrapper: css`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    height: 100px;
    flex-direction: column;

    .wrap-inner {
      display: flex;
      gap: 5px;
      align-items: center;
    }

    .upline-number {
      font-size: 18px;
      font-weight: 600;
      border: 1px solid #dadada;
      border-radius: 6px;
      width: 100%;
      padding: 5px 30px;
      background: #f1f1f1;
    }

    .btn-copy {
      cursor: pointer;
      background: none;
      border: none;
      outline: none;
      line-height: 1;
      color: #407247;
    }
  `,
};
